import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ message, isModal, onClose }) => (
  <div className={`validation-container${isModal ? ' is-modal' : ''}`}>
    <div className="validation-inner">
      <div className="message">{message}</div>
      {isModal && (
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Close
        </button>
      )}
    </div>
  </div>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isModal: PropTypes.bool,
  onClose: PropTypes.func,
};

ErrorMessage.defaultProps = {
  isModal: false,
  onClose: () => {},
};

export default memo(ErrorMessage);
